import { observer } from 'src/utils/mobx-react';

import {
    OverlayDefault,
    Content,
    PopupHeader,
    PopupDescription,
    TermsBox,
    AcceptBtn,
    LinkWrapper,
} from 'src/domains/players/webview/components/Account/Notifications/BlockingNotifications.style';
import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Policy } from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/Policy';
import { UniverseComponent } from 'src/domains/common/universes';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { useAsyncButtonAction } from 'src/domains/common/hooks/useAsyncButtonAction';

interface BlockingLicenceNotificationPropsType {
    onConfirm: () => Promise<void>;
}

export const BlockingLicenceNotification = observer(
    'BlockingLicenceNotificationPropsType',
    ({ onConfirm }: BlockingLicenceNotificationPropsType): JSX.Element | null => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        const { accountHelperMail, operatorFullName } = configState;
        const { handleClick: handleConfirm, isLoading: isConfirmLoading } = useAsyncButtonAction(onConfirm);

        return (
            <OverlayDefault data-test='overlay-prompt'>
                <Content>
                    <UniverseComponent>
                        {(universeModule): React.ReactElement => <universeModule.compliancePopupLogo />}
                    </UniverseComponent>

                    <PopupHeader>
                        <I18n
                            langKey='account.change-licence-notification.title'
                            defaultText='Change of Licence'
                        />
                    </PopupHeader>
                    <PopupDescription>
                        <I18n
                            langKey='account.change-licence-notification.description-part-1'
                            defaultText='{operatorFullName} is now operating under the {operatorFullName} Ltd Gambling Commission licence. To continue to use your account, please accept the new terms and conditions.'
                            params={{ operatorFullName }}
                        />
                    </PopupDescription>
                    <TermsBox systemPagesVariant={configState.componentVariants.systemPagesVariant}>
                        <Policy
                            leftAlign
                            id='terms-and-conditions'
                        />
                    </TermsBox>
                    <PopupDescription>
                        <I18n
                            langKey='account.change-licence-notification.description-part-2'
                            defaultText='Your account history, account balance, open bets and payment methods are unaffected. All your favourite {operatorFullName} products are still available to bet on.'
                            params={{ operatorFullName }}
                        />
                    </PopupDescription>

                    <PopupDescription>
                        <I18n
                            langKey='account.change-licence-notification.description-part-3'
                            defaultText='If you do not agree to have your account transferred to the {operatorFullName} Ltd licence, do not click the Accept button and contact'
                            params={{ operatorFullName }}
                        />{' '}
                        <LinkWrapper to={`mailto:${accountHelperMail}`}>
                            <I18n
                                langKey='account.deposit.info-page.email'
                                defaultText='{accountHelperMail}'
                                params={{ accountHelperMail }}
                            />
                        </LinkWrapper>
                    </PopupDescription>

                    <AcceptBtn
                        onClick={handleConfirm}
                        size='medium'
                        isLoading={isConfirmLoading}
                        disabled={isConfirmLoading}
                    >
                        <I18n
                            langKey='account.change-license-notification.confirm-button.label'
                            defaultText='Accept'
                        />
                    </AcceptBtn>
                </Content>
            </OverlayDefault>
        );
    }
);
